import { PayrollConstants as Constants } from '../types'

const initialState = {
    payroll: [],    
    list: [],
    total: 0,
    error: null,    
    loading: false   
};

export function payrollReducer(state = initialState, action) {
    switch (action.type) {  

        case Constants.GET:                     
            return {
                ...state,
                payroll: action?.payload?.payroll,
                total: action?.payload?.total,
                loading: false,
                error: null,
            };

        case Constants.LIST:                     
            return {
                ...state,
                list: action?.payload?.employees,
                loading: false,
                error: null,
            };

               
        case Constants.ADD:
            return {
                ...state,
                payroll: [action?.payload?.payroll, ...state?.payroll],
                loading: false,
                error: null,
            }

        case Constants.UPDATE:            
            const index = state.payroll.findIndex(x => parseInt(x.id) ===  parseInt(action?.payload?.payroll?.id))
            const newArray = [...state.payroll];
            if(index > -1)
                newArray[index] = action?.payload?.payroll
            return {
                ...state,
                payroll: newArray,
                loading: false,
                error: null,
            }   

        case Constants.DELETE:
            return{
                ...state,
                payroll: state?.payroll?.filter(x => parseInt(x?.id) !== parseInt(action?.payload?.id)),
                loading: false,
                error: null,
            };

        
        
        case Constants.FAIL:
            return{
                ...state,
                error: action?.error,
                loading: false
            }
        
        case Constants.LOADING:
            return{
                ...state,
                error: null,
                loading: true
            }

        case Constants.CLEAR:
            return{
                ...state,
                payroll: []
            }
        default:
            return state
    }
}